import { useEffect, useRef } from 'react'

/*
 * This is primarily for development mode.
 * React.Strict will cause useEffects with empty dependency arrays to fire twice.
 * This is to prevent that without needing to disable strict mode.
 * */

const useOnMount = (callback) => {
  const fetched = useRef(null)

  useEffect(() => {
    if (fetched.current) return
    callback()
    fetched.current = true
  })
}

export default useOnMount
